import { useUserStore } from '../../stores/userStore';
import { authReturnPath } from './model';
import { isCurrentTokenExpired } from '../../utils/authUtils';

const FLOW_KEY = 'POSTPOP_APPLE_WEB_FLOW';
const KEY_PATTERN = /^[A-Za-z0-9_-]{43}$/;
export const appleWebEnabled = () => process.env.REACT_APP_APPLE_WEB_LOGIN_ENABLED === 'true';
const epoch = () => localStorage.getItem('POSTPOP_AUTH_EPOCH') || '0';
const guest = () =>
  !useUserStore.getState().user && !useUserStore.getState().isLogin && isCurrentTokenExpired();

export function beginAppleFlow(returnPath) {
  if (!appleWebEnabled() || !guest()) throw new Error('Apple login unavailable');
  const bytes = window.crypto.getRandomValues(new Uint8Array(32));
  const tabKey = btoa(String.fromCharCode(...bytes))
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');
  const flow = {
    tabKey,
    returnPath: authReturnPath(returnPath),
    epoch: epoch(),
    startedAt: Date.now(),
  };
  // Fail before requesting auth if browser storage is unavailable.
  sessionStorage.setItem(FLOW_KEY, JSON.stringify(flow));
  return flow;
}
export function appleFlowCurrent(flow) {
  try {
    const age = Date.now() - flow?.startedAt;
    return (
      !!flow &&
      KEY_PATTERN.test(flow.tabKey) &&
      Number.isFinite(age) &&
      age >= 0 &&
      age < 300000 &&
      flow.epoch === epoch() &&
      guest()
    );
  } catch {
    return false;
  }
}
export function readAppleFlow() {
  try {
    const flow = JSON.parse(sessionStorage.getItem(FLOW_KEY));
    return appleFlowCurrent(flow) ? flow : null;
  } catch {
    return null;
  }
}
export function clearAppleFlow(flow) {
  try {
    // A late response from an older departure must not delete a newer attempt.
    if (!flow || JSON.parse(sessionStorage.getItem(FLOW_KEY))?.tabKey === flow.tabKey)
      sessionStorage.removeItem(FLOW_KEY);
  } catch {
    /* Storage may have been disabled while away. */
  }
}
export function appleAuthorizationUrl(value) {
  try {
    const url = new URL(value);
    return url.origin === 'https://appleid.apple.com' &&
      url.pathname === '/auth/authorize' &&
      !url.username &&
      !url.password &&
      !url.hash
      ? url.href
      : null;
  } catch {
    return null;
  }
}
export function appleCallbackInput(search) {
  const params = new URLSearchParams(search);
  const ticket = params.get('ticket');
  return {
    ticket:
      params.getAll('ticket').length === 1 && !params.has('error') && KEY_PATTERN.test(ticket || '')
        ? ticket
        : null,
    cancelled:
      params.getAll('error').length === 1 &&
      params.get('error') === 'cancelled' &&
      !params.has('ticket'),
  };
}
